/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import React from 'react';
import {Route, Switch, Redirect, withRouter} from "react-router-dom";
import LoginView from "./views/login-view";
import {useAppSelector} from "./store";

import "./style/login.css";

function AppAuthentication(props: any) {
    const {children, location} = props;
    const isAuthenticated = useAppSelector(state => state.auth.isAuthenticated);
    let next = new URLSearchParams(location.search).get("next");

    return (
        isAuthenticated ? (
            <Switch>
                <Route exact path="/login" render={() => <Redirect to={next ? next : "/"}/>}/>
                <Route path="*" children={children}/>
            </Switch>
        ) : (
            <Switch>
                <Route exact path='/login' children={<LoginView/>}/>
                <Route path="*" render={
                    ({location}) => <Redirect
                        to={location.pathname.length > 1 ? `/login?next=${location.pathname}` : '/login'}/>
                }/>
            </Switch>
        )
    )
}

export default withRouter(AppAuthentication)

